module.exports = __webpack_public_path__ + "static/media/phone-preview-form-feedback.48c5465d.png";